import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/", label: "Accueil" },
  { to: "/services", label: "Services" },
  { to: "/realisations", label: "Réalisations" },
  { to: "/a-propos", label: "À propos" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const location = useLocation();

  // Hide global navbar on portal/admin
  if (location.pathname.startsWith("/espace-client") || location.pathname.startsWith("/admin")) return null;

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 bg-black/70 backdrop-blur-xl border-b border-white/5"
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 group" data-testid="logo-link">
          <img src="/assets/logo.png" alt="DCR-BATI" className="h-14 md:h-16 w-auto" />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
              className={({ isActive }) =>
                `font-display uppercase tracking-wider text-sm transition-colors ${
                  isActive ? "text-[#ffd600]" : "text-neutral-300 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user && user !== false ? (
            <Link
              to={user.role === "admin" ? "/admin" : "/espace-client"}
              className="btn-ghost !py-2.5 !px-4 text-xs"
              data-testid="portal-cta"
            >
              <i className="fa-solid fa-helmet-safety" /> {user.role === "admin" ? "Admin" : "Mon chantier"}
            </Link>
          ) : (
            <Link to="/connexion" className="btn-ghost !py-2.5 !px-4 text-xs" data-testid="login-cta">
              <i className="fa-solid fa-lock" /> Espace client
            </Link>
          )}
          <Link to="/devis" className="btn-primary !py-2.5 !px-4 text-xs" data-testid="quote-cta">
            Demander un devis <i className="fa-solid fa-arrow-right" />
          </Link>
        </div>

        <button
          className="lg:hidden text-white p-2"
          onClick={() => setOpen((s) => !s)}
          data-testid="menu-toggle"
          aria-label="Menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/5 bg-black/95">
          <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-${l.to.replace("/", "") || "home"}`}
                className={({ isActive }) =>
                  `font-display uppercase tracking-wider text-base ${
                    isActive ? "text-[#ffd600]" : "text-neutral-200"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <div className="flex gap-3 pt-4 border-t border-white/5">
              <Link to="/connexion" className="btn-ghost flex-1 justify-center !py-3 text-xs" onClick={() => setOpen(false)}>
                Espace client
              </Link>
              <Link to="/devis" className="btn-primary flex-1 justify-center !py-3 text-xs" onClick={() => setOpen(false)}>
                Devis
              </Link>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
